import { get } from "lodash";
import {
  ATTACHMENT_TYPES,
  PROFILE_LIST,
  SITUATION_PROFESSIONAL,
  SITUATION_PROFESSIONAL_INDEPENDENT,
} from "utils/constants";

export const isLmfKbisRequired = (contact) =>
  get(contact, "socioProfessionalCategory") ===
    SITUATION_PROFESSIONAL.INDEPENDENT &&
  get(contact, "fields.socioProfessionalSubCategory") ===
    SITUATION_PROFESSIONAL_INDEPENDENT.BUSINESS_LEADER;

export const isLmfInpiRequired = (contact) =>
  get(contact, "socioProfessionalCategory") ===
    SITUATION_PROFESSIONAL.INDEPENDENT &&
  get(contact, "fields.socioProfessionalSubCategory") ===
    SITUATION_PROFESSIONAL_INDEPENDENT.SELF_EMPLOYED;

export const isLmfKbisOrInpiRequired = (contact) =>
  isLmfKbisRequired(contact) || isLmfInpiRequired(contact);

export const getLmfAdherentProofFields = (contact) => [
  `proof.adherent.${ATTACHMENT_TYPES.CIN}`,
  `proof.adherent.${ATTACHMENT_TYPES.PAYMENT_ACCOUNT}`,
  `proof.adherent.${ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE}`,
  get(contact, "fields.profile") === PROFILE_LIST.TERRITORIAL_AGENT
    ? `proof.adherent.${ATTACHMENT_TYPES.PROOF_OF_ELIGIBILITY}`
    : undefined,
  isLmfKbisRequired(contact)
    ? `proof.adherent.${ATTACHMENT_TYPES.KBIS}`
    : undefined,
  isLmfInpiRequired(contact)
    ? `proof.adherent.${ATTACHMENT_TYPES.INPI}`
    : undefined,
];

export const getLmfPayerProofFields = (contact) => [
  `proof.payer.${ATTACHMENT_TYPES.PAYER_CIN}`,
  ...(isLmfKbisOrInpiRequired(contact)
    ? []
    : [`proof.payer.${ATTACHMENT_TYPES.CONTRIBUTION_PAYMENT_AGREEMENT}`]),
  `proof.payer.${ATTACHMENT_TYPES.PAYER_RIB}`,
];
